<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="amazon" :title="$t('amazon.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !amazonAccount.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': amazonAccount.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="amazonAccount.logo" :src="amazonAccount.logo"/>
          <i v-if="!amazonAccount.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Nome:</strong> {{ amazonAccount.shopName | attribute }}</span>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ amazonAccount.accessToken | attribute }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ amazonAccount.refreshToken | attribute }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ amazonAccount.expirationDate.replace('.000Z', '') | moment('DD/MM/YYYY HH:mm') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      amazonAccount: {},
      loading: true
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('amazonAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.amazonAccount.active,
          'error': !this.amazonAccount.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'amazon.accounts.active.label'
        }
        return 'amazon.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`marketplace/amazon/accounts/` + this.amazonAccount.partnerId)
      },
      async refreshToken () {
        try {
          const refreshedAccount = (await api.amazon.refreshToken(this.amazonAccount.partnerId))

          this.amazonAccount = refreshedAccount
          this.setAccount(refreshedAccount)

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        if (this.amazonAccount.active === status) {
          return false
        }

        try {
          await api.amazon.updateAccountStatus(this.amazonAccount.partnerId, status)

          this.amazonAccount.active = status

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      }
    },
    computed: {
      ...mapGetters('amazonAccounts', [
        'getAccount'
      ]),
      async account () {
        this.amazonAccount = await api.amazon.getAccountByPartnerId(this.identifier)
        return this.amazonAccount
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey
</style>



// WEBPACK FOOTER //
// Edit.vue?d7d5f792